export const DELIVERY_COUNTRIES = {
  RU: "Россия",
  BY: "Беларусь",
  KZ: "Казахстан",
};

export function deliveryCountryName(code) {
  return DELIVERY_COUNTRIES[code] || "";
}

export function normalizeDeliveryPhone(value) {
  let digits = String(value || "").replace(/\D/g, "");
  if (digits.length === 10) digits = `7${digits}`;
  if (digits.length === 11 && digits.startsWith("8")) digits = `7${digits.slice(1)}`;
  if (digits.length === 11 && digits.startsWith("7")) return `+${digits}`;
  if (digits.length === 12 && digits.startsWith("375")) return `+${digits}`;
  return "";
}

export function pickupPointLabel(point) {
  if (point.is_partner || point.source === "tvzgo") {
    return point.label || [point.code, point.city, point.address].filter(Boolean).join(" · ");
  }
  return point.name || point.label || point.code;
}

export function deliveryDestinationKey(form) {
  return [form.deliveryType || "cdek", form.countryCode || "RU", form.deliveryProvider || "cdek",
    form.cityRef || "", form.cityCode || "", form.pvzCode || ""].join("|");
}
